import React from "react";

//Material-UI Core Components
import Box from "@material-ui/core/Box";

//Custom Components
import PrijevozniciPage from "UI/AppPage/PrijevozniciPage";
import ProfileForm from "Views/ProfilePage/ProfileForm";

const PrijevozniciProfilePage = React.memo((props) => {
  return (
    <PrijevozniciPage>
      <Box m={2}>
        <ProfileForm />
      </Box>
    </PrijevozniciPage>
  );
})

export default PrijevozniciProfilePage;
